import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoBackService implements OnDestroy {
  constructor(private router: Router) {
    router.events
      .pipe(
        takeUntil(this.onDestroy$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        this.setURLs(event);
      });
  }

  private previousUrl = '';
  private currentUrl = '';
  private onDestroy$ = new Subject<void>();

  public get canGoBack() {
    return !!this.previousUrl;
  }
  public goBack() {
    this.router.navigateByUrl(this.previousUrl);
  }

  private setURLs(event: NavigationEnd): void {
    this.previousUrl = this.currentUrl;
    this.currentUrl = event.urlAfterRedirects;
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
